// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-lottie-loader',
//   templateUrl: './lottie-loader.component.html',
//   styleUrls: ['./lottie-loader.component.scss'],
// })
// export class LottieLoaderComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {}

// }
// import { Component } from '@angular/core';
// import { LoaderService } from '../../../app/mastermodule/service/loader.service';
//  // adjust path if needed

// @Component({
//   selector: 'app-loader',
//   templateUrl: './loader.component.html',
//   styleUrls: ['./loader.component.scss'],
// })
// export class LoaderComponent {
//   show = false;

//   options = {
//     path: 'assets/loader/website_loader.json',
//     loop: true,
//     autoplay: true
//   };

//   constructor(private loaderService: LoaderService) {
//     this.loaderService.loading$.subscribe(val => {
//       this.show = val;
//     });
//   }
// }

// import { Component, AfterViewInit, Input } from '@angular/core';
// import lottie from 'lottie-web';

// @Component({
//   selector: 'app-loader',
//   templateUrl: './loader.component.html',
//   styleUrls: ['./loader.component.scss'],
//   standalone: false,
// })
// export class LoaderComponent implements AfterViewInit {
//   @Input() isVisible: boolean = false;

//   ngAfterViewInit() {
//     const container = document.getElementById('lottie-loader');
//     if (container) {
//       lottie.loadAnimation({
//         container,
//         renderer: 'svg',
//         loop: true,
//         autoplay: true,
//         path: 'assets/loader/app_loader.json'
//       });
//     }
//   }
// }



// import { Component, Input, AfterViewInit, OnChanges } from '@angular/core';
// import lottie from 'lottie-web';

// @Component({
//   selector: 'app-lottie-loader',
//   templateUrl: './lottie-loader.component.html',
//   styleUrls: ['./lottie-loader.component.scss'],
//   standalone: false,
// })
// export class LoaderComponent implements AfterViewInit, OnChanges {
//   @Input() isVisible: boolean = false;

//   ngAfterViewInit() {
//     this.initLoader();
//   }

//   ngOnChanges() {
//     if (this.isVisible) {
//       this.initLoader();
//     }
//   }

//   initLoader() {
//     const container = document.getElementById('lottie-loader');
//     if (container && container.childElementCount === 0) {
//       lottie.loadAnimation({
//         container,
//         renderer: 'svg',
//         loop: true,
//         autoplay: true,
//         path: 'assets/loader/app_loader.json'
//       });
//     }
//   }
// }


import { Component, Input, AfterViewInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import lottie from 'lottie-web';

@Component({
  selector: 'app-lottie-loader',
  templateUrl: './lottie-loader.component.html',
  styleUrls: ['./lottie-loader.component.scss'],
})
export class LoaderComponent implements AfterViewInit, OnChanges {
  @Input() isVisible: boolean = false;
  private animation: any;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit() {
    if (this.isVisible) {
      // Delay to ensure view is fully rendered
      setTimeout(() => this.initLoader(), 0);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isVisible']) {
      if (changes['isVisible'].currentValue === true) {
        setTimeout(() => this.initLoader(), 0); // Ensure DOM is ready
      } else {
        this.destroyLoader();
      }
    }
  }

  initLoader() {
    const container = this.elRef.nativeElement.querySelector('#lottie-loader');
    if (container) {
      container.innerHTML = ''; // clear old animation
      this.animation = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'assets/loader/app_loader.json' // ✅ path should be relative to assets
      });
    } else {
      console.warn('Lottie container not available yet');
    }
  }

  destroyLoader() {
    if (this.animation) {
      this.animation.destroy();
    }
  }
}






